import React from "react"
import { useAppState } from "@hooks/index"

import { Badge } from "@mui/material"

import { useGetCartItemsQuery } from "../cart-slice"

interface CartNotifProps {
  children?: React.ReactNode
  variant?: string | any
}

const CartNotification = ({ children, ...props }: CartNotifProps) => {
  const { global } = useAppState()

  const { data, isFetching } = useGetCartItemsQuery({ uid: global.user.uid })

  return (
    <>
      {data && !isFetching && data.length ? (
        <Badge badgeContent={data.length} color="error" {...props}>
          {children}
        </Badge>
      ) : (
        children
      )}
    </>
  )
}

export default CartNotification
